import { render, staticRenderFns } from "./SField.vue?vue&type=template&id=8808b100&scoped=true&"
import script from "./SField.vue?vue&type=script&lang=js&"
export * from "./SField.vue?vue&type=script&lang=js&"
import style0 from "./SField.vue?vue&type=style&index=0&id=8808b100&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8808b100",
  null
  
)

export default component.exports